import React from "react";

const CreditCard = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 17.4308C18.97 20.2808 18.19 21.0008 15.22 21.0008H5.78003C2.76003 21.0008 2 20.2508 2 17.2708V10.2808C2 7.58078 2.63 6.71078 5 6.57078C5.24 6.56078 5.50003 6.55078 5.78003 6.55078H15.22C18.24 6.55078 19 7.30078 19 10.2808V17.4308Z"
        fill="#3D68FF"
      />
      <path
        d="M22 13.72C22 16.42 21.37 17.29 19 17.43V10.28C19 7.3 18.24 6.55 15.22 6.55H5.78003C5.50003 6.55 5.24 6.56 5 6.57C5.03 3.72 5.81003 3 8.78003 3H18.22C21.24 3 22 3.75 22 6.73V13.72Z"
        fill="#3055D4"
      />
      <path
        d="M5.24023 18.5586C4.83023 18.5586 4.49023 18.2186 4.49023 17.8086C4.49023 17.3986 4.83023 17.0586 5.24023 17.0586H6.96027C7.37027 17.0586 7.71027 17.3986 7.71027 17.8086C7.71027 18.2186 7.38027 18.5586 6.96027 18.5586H5.24023Z"
        fill="white"
      />
      <path
        d="M9.10938 18.5586C8.69938 18.5586 8.35938 18.2186 8.35938 17.8086C8.35938 17.3986 8.69938 17.0586 9.10938 17.0586H12.5494C12.9594 17.0586 13.2994 17.3986 13.2994 17.8086C13.2994 18.2186 12.9694 18.5586 12.5494 18.5586H9.10938Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11.8594V13.3594H2V11.8594H19Z"
        fill="white"
      />
    </svg>
  );
};

export default CreditCard;
